<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
    class="left-sidebar">
    <v-layout
      justify-center
      wrap>
    <v-flex
        md12>
      <!-- add product dialog -->
        <v-dialog
            v-model="addProductDialog"
            persistent
            max-width="550"
            content-class="dialog-color"
        >
          <v-card-title class="text-h6">
             {{ $t('products.addNewProduct')}}
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-text>
          <v-form ref="addProductForm">
            <v-row class="dialog-card-body">
            <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="productName"
                  :label="$t('products.name')"
                  :placeholder="$t('products.name')"
                  :error-messages="productNameErrors"
                />
                <v-select
                  v-model="category"
                  :items="getCategories"
                  :label="$t('products.categories')"
                  :placeholder="$t('products.categories')"
                  :error-messages="categoriesErrors"
                  item-text="name"
                  item-value="id"
              ></v-select>
                <v-text-field
                  v-model="price"
                  :label="$t('products.price')"
                  :placeholder="$t('products.price')"
                  :error-messages="priceErrors"
                />
                <v-text-field
                  v-model="weight"
                  :label="$t('products.weight')"
                  :placeholder="$t('products.weight')"
                  :error-messages="weightErrors"
                />
                <v-text-field
                  v-model="description"
                  :label="$t('products.description')"
                  :placeholder="$t('products.description')"
                  :error-messages="descriptionErrors"
                />
                <v-text-field
                  v-model="shortDescription"
                  :label="$t('products.shortDescription')"
                  :placeholder="$t('products.shortDescription')"
                  :error-messages="shortDescriptionErrors"
                />
                <v-text-field
                  v-model="specification"
                  :label="$t('products.specification')"
                  :placeholder="$t('products.specification')"
                  :error-messages="specificationErrors"
                />
              <input id="product-image" type='file' accept="image/*"/><br>
              <img id="productImage">
            </v-col>
            </v-row>
        </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="add-new mb-1 mt-8 mr-3"
              dark
              @click="cancelProduct()"
              >
              {{ $t('cancel')}}
            </v-btn>
            <v-btn
              class="add-new mb-1 mt-8 mr-3"
              dark
              @click="createProduct()">
              {{ $t('submit')}}
            </v-btn>
          </v-card-actions>
      </v-dialog>
        <v-card
        elevation="2"
        class="card-body">
        <v-card>
            <v-card-title>{{ $t('products.title')}}</v-card-title>
        </v-card>
        <v-spacer/>
        <div>
        <v-btn
            dark
            class="add-new mb-1 mt-8 mr-3"
            @click="openCreateProduct()">{{ $t('products.newProduct') }}</v-btn>
            <br>
            <v-btn
              class="add-new mb-1 mt-8 mr-3 remove-products"
              dark
              @click="removeProducts()"
              >{{ $t('products.delete') }}</v-btn>
          </div>
          <v-text-field
            :search="search"
            :label="$t('search')"
            :placeholder="$t('search')"
            single-line
            hide-details
            class="search-field">
            </v-text-field>
            <v-data-table
              :headers="headers"
              :items="getAllProducts"
              :rows-per-page-items ="rowsAmount"
              :search="search"
              class="elevation-1"
            >
              <template  v-slot:item="props">
                           <!-- {{props.item}}  -->
                <tr v-if="getAllProducts">
                  <th>
                  <v-checkbox
                    :input-value="props.all"
                    :indeterminate="props.indeterminate"
                    primary
                    hide-details
                    :checked="selected.includes(props.item.id)"
                   @click="getSeletctedProducts(props.item.id)"
                  ></v-checkbox>
                </th>
                <td class="justify-center icon-table-wrap">
                      <v-icon
                          medium
                          class="icon-table"
                          @click="openEditProduct(props)">mdi-pencil</v-icon>
                  </td>
                  <td class="justify-center icon-table-wrap">
                      <v-icon
                          medium
                          class="icon-table"
                          @click="deleteProduct(props)">mdi-delete</v-icon>
                  </td>
                  <td>
                    <div>{{ props.item.title }}</div>
                  </td>
                  <td>
                    <div v-if="props.item.images">
                        <img class="table-image" v-bind:src=props.item.images[0]>
                    </div>
                    <div v-else>---</div>
                  </td>
                  <td>
<!--                    <div>{{ props.item && props.item.prices[0] ? props.item.prices[0].value + ' ' + props.items.prices[0].currency : '' }}</div>-->
                    {{props.item.prices[0] && props.item.prices[0].value + ' ' + props.item.prices[0].currency}}
                  </td>
                  <td>
                    <div v-if="props.item.sku">{{ props.item.sku }}</div>
                    <div v-else>-</div>
                  </td>
                </tr>
              </template>
            </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import {  mapGetters } from 'vuex';
  import { required, numeric } from 'vuelidate/lib/validators'
  import i18n from '../../i18n'
  export default {
      data () {
          return {
              search: '',
              addProductDialog: false,
              productName: '',
              category: null,
              weight: '',
              description: '',
              shortDescription: '',
              specification: '',
              price: '',
              selected: [],
              isDisabledProductsBtn: true,
              rowsAmount: [10,20,25,{"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}],
              headers: [
                  { text: i18n.t(''),},
                  { text: i18n.t(''),},
                  { text: i18n.t(''),},
                  { text: i18n.t('products.title'), value: 'title'},
                  { text: i18n.t('products.image'), value: 'image'},
                  { text: i18n.t('products.price'), value: 'price'},
                  { text: i18n.t('products.sku'), value: 'sku'},
              ],
          }
      },
      validations: {
          productName: { required },
          category: { required },
          price: { required, numeric },
          weight: { required, numeric },
          description: { required },
          shortDescription: { required },
          specification: { required },
      },
      computed: {
        ...mapGetters([
            'getAllProducts',
            'getAllCategories'
        ]),
        getCategories(){
            return [].concat.apply([], this.getAllCategories.map(el => el.subcategories));
        },
        productNameErrors(){
            const errors = [];
                if (!this.$v.productName.$dirty) return errors;
                    !this.$v.productName.required && errors.push(i18n.tc('fieldRequired'));
                return errors;
        },
        categoriesErrors(){
            const errors = [];
                if (!this.$v.category.$dirty) return errors;
                    !this.$v.category.required && errors.push(i18n.tc('fieldRequired'));
                return errors;
        },
        priceErrors(){
            const errors = [];
                if (!this.$v.price.$dirty) return errors;
                    !this.$v.price.required && errors.push(i18n.tc('fieldRequired'));
                    !this.$v.price.numeric && errors.push(i18n.tc('fieldValueNumber'));
                return errors;
        },
        weightErrors(){
            const errors = [];
                if (!this.$v.weight.$dirty) return errors;
                    !this.$v.weight.required && errors.push(i18n.tc('fieldRequired'));
                    !this.$v.weight.numeric && errors.push(i18n.tc('fieldValueNumber'));
                return errors;
        },
        descriptionErrors(){
            const errors = [];
                if (!this.$v.description.$dirty) return errors;
                    !this.$v.description.required && errors.push(i18n.tc('fieldRequired'));
                return errors;
        },
        shortDescriptionErrors(){
            const errors = [];
                if (!this.$v.shortDescription.$dirty) return errors;
                    !this.$v.shortDescription.required && errors.push(i18n.tc('fieldRequired'));
                return errors;
        },
        specificationErrors(){
            const errors = [];
                if (!this.$v.specification.$dirty) return errors;
                    !this.$v.specification.required && errors.push(i18n.tc('fieldRequired'));
                return errors;
        },
      },
      methods:{
        getSeletctedProducts(lang){
          let index;
            if ((index = this.selected.indexOf(lang)) === -1) {
              this.selected.push(lang)
              document.querySelector('.remove-products').style.display = 'block';
            } else {
              this.selected.splice(index, 1)
            }
            if(this.selected.length == 0){
              document.querySelector('.remove-products').style.display = 'none';
            }
        },
        removeProducts(){
          if (confirm(i18n.t(`areYouSureToDelete`))) {
              this.$store.dispatch('DELETE_PRODUCTS', this.selected)
                  .then(() => this.$store.dispatch('LOAD_ALL_PRODUCTS'))
                  this.selected = []
            }
        },
        cancelProduct(){
            this.addProductDialog = false;
            this.resetProductForm();
        },
        resetProductForm(){
            this.$refs.addProductForm.reset();
            this.$v.$reset();
            document.getElementById('product-image').value = '';
            document.getElementById('product-image').style.color = 'black';
        },
        openCreateProduct(){
            this.$router.push(`/${i18n.locale}/products/add-new-product`)
        },
        createProduct(){
          const productFile = document.getElementById('product-image').files[0];

          let formData = new FormData();
              formData.append('image', productFile);
              formData.append('price', this.price);
              formData.append('weight', this.weight);
              formData.append('category_id', this.category);
              formData.append('translations[0][title]', this.productName);
              formData.append('translations[0][short_description]', this.shortDescription);
              formData.append('translations[0][description]', this.description);
              formData.append('translations[0][specification]', this.specification);
              formData.append('translations[0][language_identifier]', 'sr');


            if(this.$v.productName.$invalid || this.$v.price.$invalid ||
                this.$v.weight.$invalid || this.$v.category.$invalid
                || this.$v.shortDescription.$invalid || this.$v.description.$invalid
                || this.$v.specification.$invalid ||  productFile.value == ''){
                this.$v.$touch();
                document.getElementById('product-image').style.color = 'red';
                return;
            } else {
                this.$store.dispatch('CREATE_PRODUCT', formData)
                    .then(() => this.$store.dispatch('LOAD_ALL_PRODUCTS'));
                this.addProductDialog = false;
                this.resetProductForm();
            }
        },
        openEditProduct(props){
          this.$router.push(`/${i18n.locale}/products/edit-product/${props.item.id}`)
        },
        deleteProduct(props){
            if (confirm(i18n.t(`areYouSureToDelete_`) + `${props.item.title}?`)) {
              this.$store.dispatch('DELETE_PRODUCT', props.item.id)
                  .then(() => this.$store.dispatch('LOAD_ALL_PRODUCTS'));
            }
        },
      },
      beforeCreate() {
          this.$store.dispatch('LOAD_ALL_PRODUCTS');
          this.$store.dispatch('LOAD_ALL_CATEGORIES');
      },
      mounted() {
          this.$store.dispatch('LOAD_ALL_PRODUCTS');
          this.$store.dispatch('LOAD_ALL_CATEGORIES');
      },
  }
</script>

<style lang="less" scoped>
  .remove-products{
    display: none;
  }
</style>
